const splitTypeEntry = (typeEntry) => {
    return typeEntry
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
};
export const parseModelTypes = (typeField) => {
    if (!typeField)
        return [];
    const source = Array.isArray(typeField) ? typeField : [typeField];
    return Array.from(new Set(source.flatMap(splitTypeEntry)));
};
export const formatModelType = (typeField, fallback = 'Concept') => {
    const normalizedTypes = parseModelTypes(typeField);
    return normalizedTypes.length > 0 ? normalizedTypes.join(', ') : fallback;
};
